import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSell = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSell",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M856-390 570-104q-12 12-27 18t-30 6-30-6-27-18L103-457q-11-11-17-25t-6-31v-287q0-33 24-56t56-24h287q16 0 31 7t26 17l352 353q12 12 18 27t5 30-5 30-18 26M260-640q25 0 43-17t17-43-17-42-43-18-42 18-18 42 18 43 42 17"
  })
}));
IconSell.displayName = 'IconSell';